import "./Header.css";
import avatar from "../../Images/hawaiipic.jpg";
import linkedinIcon from "../../SVGS/linkedin-original.svg";

function Header() {
  return (
    <div className="Profile-Header-Bg">
      <div className="Profile-Header-Bg-Texture">
        <div className="Profile-Header">
          <div className="Profile-Header-Content">
            <div className="Profile-Header-Centered-Persona">
              <div className="Persona-Name">
                <span>Brandon Fry-Bailey</span>
              </div>
              <div className="Persona-ExtraInfo">
                <img
                  src="https://community.fastly.steamstatic.com/public/images/countryflags/us.gif"
                  alt=""
                  className="Persona-Flag"
                />{" "}
                Seattle, Washington, United States
              </div>
            </div>
            <div className="Profile-Header-Avatar">
              <div className="Profile-Header-Avatar-AutoSize">
                <div className="Profile-Header-Avatar-Frame">
                  <img
                    className="Profile-Header-Avatar-Frame-Img"
                    src="https://cdn.cloudflare.steamstatic.com/steamcommunity/public/images/items/1127700/0a006140df75df78a40df5081313d0856a52069f.png"
                    alt=""
                  />
                </div>
                <img
                  className="Profile-Header-Avatar-Img"
                  src={avatar}
                  alt=""
                />
              </div>
            </div>
            <div className="Profile-Header-BadgeInfo">
              <div className="Profile-Badges-Container">
                <div className="Profile-Age">
                  Level{" "}
                  <div className="Profile-Age-Display">
                    <span>26</span>
                  </div>
                </div>
              </div>
              <div className="LinkedIn-Badge">
                <a
                  href="https://www.linkedin.com/in/brandon-fry-bailey/"
                  target="_blank"
                  rel="noreferrer"
                  className="LinkedIn-Badge-Link"
                >
                  <img className="LinkedIn-Badge-Icon" src={linkedinIcon} />
                  <div className="LinkedIn-Badge-Title">
                    <div>LinkedIn</div>
                    <div>500 XP</div>
                  </div>
                </a>
              </div>
              <a
                className="View-Live-Version-Button"
                href="https://brandonfrybailey.com/"
                target="_blank"
                rel="noreferrer"
              >
                <span>View Live Version</span>
              </a>
            </div>
            <div className="Profile-Header-Objective-Statement">
              <div className="Persona-Name Persona-Name-Spacer">&nbsp;</div>
              <div className="Persona-ExtraInfo Persona-ExtraInfo-Spacer">
                &nbsp;
              </div>
              <div className="Profile-Objective-Statement">
                Passionate software developer with a versatile background in web
                development and game programming, ready to leverage my skills in
                software design and implementation to drive impactful projects.
                Dedicated to developing innovative solutions that enhance user
                experiences.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
